import { api } from '../api';
import { Profile } from '../../entities/Profile';

export const getProfileByType = async (type: string): Promise<Profile> => {
  const { data } = await api.get(`/roles/${type}`);

  return data;
};
